import React from 'react';
import AgreementLiveTermsPageContent from '../../AgreementLiveTerms/Components/AgreementLiveTermsPageContent';

export default function AgreementLiveTermsPage() {
    return <AgreementLiveTermsPageContent />;
}
